module.exports = __webpack_public_path__ + "img/drink.2c580481.jpg";